export default __webpack_public_path__ + "static/media/luna.bd44f8ac.svg";